import * as React from 'react'
import { Box, Typography } from '@material-ui/core'
import { Title } from 'react-admin'
import logo from '../../assets/logo.png'

export default ({ onClickAdmin, onClickAnalytics }) => (
  <Box display="flex" flexDirection="column" alignItems="center">
    <Title title="Dashboard" />
    <Box my={2} />
    <Typography
      variant="h5"
      children="Welcome to the AETC administration panel"
    />
    <Box my={2} />
    <img style={{ maxWidth: 500 }} src={logo} alt="logo" />
  </Box>
)
